import type { SubscriptionContractDto } from '#shared/types/core/ecommerce/subscriptions'

export function useSubscriptionsApi() {
  const api = useCoreApi('ecommerce/subscriptions')

  return {
    async getSubscriptions() {
      return await api.$fetch<Array<SubscriptionContractDto>>(api.rootUrl)
    },

    async updateSubscriptionQuantity(id: UUID, quantity: number, isInSalePeriod: boolean) {
      return await api.$fetch<SubscriptionContractDto>(`${api.endpoint(id, 'update', String(quantity))}?isInSalePeriod=${isInSalePeriod}`, {
        method: 'PATCH',
      })
    },

    async cancelSubscription(id: UUID) {
      return await api.$fetch<void>(api.endpoint(id, 'cancel'), {
        method: 'POST',
      })
    },
  }
}
